import { render, staticRenderFns } from "./SelectRoles.vue?vue&type=template&id=4fb6abed&scoped=true&"
import script from "./SelectRoles.vue?vue&type=script&lang=js&"
export * from "./SelectRoles.vue?vue&type=script&lang=js&"
import style0 from "./SelectRoles.vue?vue&type=style&index=0&id=4fb6abed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb6abed",
  null
  
)

export default component.exports